module.exports = __webpack_public_path__ + "static/media/facture_grey.d82ec5d4.svg";